import React, { useState, useMemo } from "react";
import Avatar from "../../components/common/Avatar";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import SkeletonDistributorListing from "../common/skeletonDistributorListing";

const DistributerMasterGrid = (props) => {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex) || [];
  }, [currentPage, filteredResults, count]);
  return (
    <>
      <div className="row distributor-table-row mb-4rem">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {loading === true ? (
            <>
                <SkeletonDistributorListing rows={12} />
            </>
          ) : currentTableData.length > 0 ? (
            <div className="card mt-0 distributor-list-card">
              <div className="card-body">
                <div className="table-responsive distributor-table-responsive">
                  <table className="table table-borderless table-list distributor-table-list">
                    <thead>
                      <tr>
                        <th><div>DISTRIBUTOR</div></th>
                        <th><div>DISTRIBUTOR TYPE</div></th>
                        <th><div>COMPANY NAME</div></th>
                        <th><div>EMAIL</div></th>
                        <th><div>ASSIGNED ENGINEER</div></th>
                        <th><div>COUNTRY</div></th>
                        <th><div>STATUS</div></th>
                        <th><div>ACTIONS</div></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((items, index) => (
                        <tr key={items?.id || index}>
                          <td
                            onClick={menuRights?.canView === true ? () => handleView(items) : undefined}
                            className={menuRights?.canView === true ? "clickable-cell" : ""}
                          >
                            <div className="distributor-cell">
                              <Avatar preName={items?.distributorName} />
                              <h4 title={items?.distributorName}>{items?.distributorName || "-"}</h4>
                            </div>
                          </td>
                          <td><h5 title={items?.type}>{items?.type || "-"}</h5></td>
                          <td><h5 title={items?.companyName}>{items?.companyName || "-"}</h5></td>
                          <td><h5 title={items?.email}>{items?.email || "-"}</h5></td>
                          <td><h5 title={items?.assignedEngineerName}>{items?.assignedEngineerName || "-"}</h5></td>
                          <td><h5 title={items?.countryName}>{items?.countryName || "-"}</h5></td>
                          <td>
                            <button
                              type="button"
                              className={items?.isActive === true ? "btn active-btn" : "btn inactive-btn"}
                            >
                              {items?.status || (items?.isActive === true ? "Active" : "Inactive")}
                            </button>
                          </td>
                          <td>
                            {((menuRights?.canEdit === true || menuRights?.canDelete === true) && (items?.systemDefault !== true)) && (
                              <div className="dropdown dropleft text-align action-menu">
                                <span
                                  className="action-icon"
                                  title="Actions"
                                  id={`distributorDropdownMenuButton-${items?.id || index}`}
                                  data-toggle="dropdown"
                                  aria-haspopup="false"
                                  aria-expanded="false"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </span>
                                <div
                                  className="dropdown-menu p-0"
                                  aria-labelledby={`distributorDropdownMenuButton-${items?.id || index}`}
                                >
                                  <ul>
                                    {menuRights?.canEdit === true && (
                                      <li>
                                        <span onClick={() => handleEdit(items)}>
                                          <i className="far fa-edit"></i> Edit
                                        </span>
                                      </li>
                                    )}
                                    {menuRights?.canDelete === true && (
                                      <li>
                                        <span onClick={() => handleDelete(items)}>
                                          <i className="far fa-trash-alt mr-1"></i> Delete
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <NotFound />
          )}
        </div>
      </div>
      {currentTableData.length > 0 && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default DistributerMasterGrid;
